import { CacheOptions } from '@/entities/cache';
import { cacheService as uiCoreCacheService } from '@ol/ol-ui-core';

class CacheService {
  public async getItem<T>(cacheName: string, cacheKey: string, cacheOptions?: CacheOptions): Promise<T> {
    const result: T = await uiCoreCacheService.getItem(cacheName, cacheKey, cacheOptions);
    return result;
  }

  public async setItem<T>(cacheName: string, cacheKey: string, cacheValue: T, cacheOptions?: CacheOptions): Promise<T> {
    const result: T = await uiCoreCacheService.setItem(cacheName, cacheKey, cacheValue, cacheOptions);
    return result;
  }

  public async removeItem(cacheName: string, cacheKey: string): Promise<void> {
    await uiCoreCacheService.removeItem(cacheName, cacheKey);
  }
  public async clear(cacheName: string): Promise<void> {
    await uiCoreCacheService.clear(cacheName);
  }

  public async clearAll(): Promise<void> {
    await uiCoreCacheService.clearAll();
  }
}

const cacheService: CacheService = new CacheService();
export default cacheService;
